<div class="dialog">
  <div class="fx--h fx--juc-space-between fx--ali-center dialog__header">
    <div mat-dialog-title>
      <h2 l10nTranslate>shared.alert</h2>
    </div>
    <mat-icon aria-hidden="false" aria-label="Close icon" (click)="onClose(false)">close</mat-icon>
  </div>

  <div mat-dialog-content>
    <div class="dialog__body">
      <div class="fx--h fx--ali-center fx--pb-20 message">
        <mat-icon class="mat-icon fx--ali-center" svgIcon="alert-icon"></mat-icon>
        <p [innerHTML]="messageOne"></p>
      </div>
      <div class="fx--h message fx--ali-center" *ngIf="propertySet.is_statistical">
        <div class="statistical-chip">S</div>
        <p [innerHTML]="messageTwo"></p>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="fx--h fx--juc-center fx--pt-20">
      <button mat-button color="primary" class="fx--mr-sm" (click)="onClose(false)" l10nTranslate>
        shared.psCancel
      </button>
      <button mat-flat-button color="primary" (click)="removeFromPropertySet()" l10nTranslate>shared.remove</button>
    </div>
  </div>
</div>
